import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {execBI} from '../services/bi-events-manager';
import LmSelect from '../components/Lm-select';
import {changeVertical} from '../actions/mode';
import {verticalsList} from '../actions/collection';
import {popupHide} from '../actions/popup';


class CollectionChange extends React.Component {

  constructor(props) {
    super(props);
    this.newVertical = null;
  }

  handleChangeVertical(ev) {
    ev.preventDefault();
    const oldVertical = this.props.vertical;
    const vertical = this.newVertical && this.newVertical.value;
    this.hide('success');

    if (vertical && oldVertical !== vertical) {
      this.props.dispatch(changeVertical(vertical));

      execBI('SITE_PROFILE_CHANGED', {vertical, oldVertical});
      execBI('COLLECTIONS_VERTICAL_SELECTED', {vertical, oldVertical});
    }
  }

  hide(method) {
    this.props.dispatch(popupHide({method}));
  }

  handleToggleChangePopup(ev, method) {
    ev.preventDefault();
    this.hide(method);
  }

  closeFixedPopup(ev) {
    if (ev.target === this.popup) {
      this.hide('outside');
    }
  }

  render() {
    const {formatMessage} = this.props.intl;
    this.newVertical = null;
    const vertical = this.props.vertical;
    const translatedVerticalsList = verticalsList.map(i => {
      return {key: i.key, title: formatMessage({id: i.title})};
    });

    return (
      <div className="apps-collection-change fixed-popup fixed-popup-center" ref={(i) => this.popup = i} onClick={(ev) => this.closeFixedPopup(ev)}>
        <div className="vertical-align-helper"></div>
        <div className="category-picker-content">
          <div className="category-picker-head"></div>
          <div className="category-picker-icons"></div>
          <a className="close-icon-button" href="#" onClick={(ev) => this.handleToggleChangePopup(ev, 'x')}>
            <svg width="25" height="25" viewBox="0 0 25 25"><path d="M11.793 12.5L8.146 8.854 7.793 8.5l.707-.707.354.353 3.646 3.647 3.646-3.647.354-.353.707.707-.353.354-3.647 3.646 3.647 3.646.353.354-.707.707-.354-.353-3.646-3.647-3.646 3.647-.354.353-.707-.707.353-.354 3.647-3.646z"></path></svg>
          </a>
          <h3 className="category-picker-slogan"><FormattedMessage id="editor.collections.get.best"/></h3>
          <div className="category-picker-desc"><FormattedMessage id="editor.collections.what.website"/></div>

          <LmSelect list={translatedVerticalsList} selected={vertical} onchange={i => this.newVertical = i}/>

          <div className="button-holder">
            <a href="#" onClick={(ev) => this.handleChangeVertical(ev)} className="button button-blue button-blue-large">
              <FormattedMessage id="application.view.apps"/>
            </a>
          </div>
          <a className="category-picker-cancel" href="#" onClick={(ev) => this.handleToggleChangePopup(ev, 'cancel')}>
            <FormattedMessage id="application.button.cancel"/>
          </a>
        </div>
      </div>
    );
  }


  static propTypes = {
    dispatch: PropTypes.func,
    vertical: PropTypes.string,
    intl: intlShape.isRequired
  };
}

function mapStateToProps(state) {
  return {vertical: state.mode.siteProfile.vertical};
}

export default connect(mapStateToProps)(injectIntl(CollectionChange));



// WEBPACK FOOTER //
// ./components/Collection-change.js